import "@/App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import PublicHeader from "@/components/PublicHeader";
import Footer from "@/components/Footer";
import WorldMapBackground from "@/components/WorldMapBackground";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";

import Landing from "@/pages/Landing";
import Comparison from "@/pages/Comparison";
import Pricing from "@/pages/Pricing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";

import Dashboard from "@/pages/app/Dashboard";
import CareerPassport from "@/pages/app/CareerPassport";
import FindJobs from "@/pages/app/FindJobs";
import CareerIntelligence from "@/pages/app/CareerIntelligence";
import ATSChecker from "@/pages/app/ATSChecker";
import JDCustomizationStudio from "@/pages/app/JDCustomizationStudio";
import ApplicationAutofill from "@/pages/app/ApplicationAutofill";
import ApplicationTracker from "@/pages/app/ApplicationTracker";
import InterviewCopilot from "@/pages/app/InterviewCopilot";
import FaceToFaceInterview from "@/pages/app/FaceToFaceInterview";
import CareerAnalytics from "@/pages/app/CareerAnalytics";

import RecruiterDashboard from "@/pages/recruiter/RecruiterDashboard";
import CandidateSearch from "@/pages/recruiter/CandidateSearch";
import CandidateDetail from "@/pages/recruiter/CandidateDetail";
import PostJob from "@/pages/recruiter/PostJob";
import RecruiterPipeline from "@/pages/recruiter/RecruiterPipeline";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) { el.scrollIntoView({ behavior: "smooth" }); return; }
    }
    window.scrollTo({ top: 0 });
  }, [pathname, hash]);
  return null;
}

function PublicLayout() {
  return (
    <div className="relative min-h-screen">
      <WorldMapBackground />
      <PublicHeader />
      <Outlet />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/compare" element={<Comparison />} />
            <Route path="/pricing" element={<Pricing />} />
          </Route>

          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          <Route path="/app" element={<ProtectedRoute role="job_seeker"><AppShell /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="passport" element={<CareerPassport />} />
            <Route path="jobs" element={<FindJobs />} />
            {/* <Route path="intelligence" element={<CareerIntelligence />} /> */}
            <Route path="ats" element={<ATSChecker />} />
            <Route path="customize" element={<JDCustomizationStudio />} />
            {/* <Route path="autofill" element={<ApplicationAutofill />} /> */}
            <Route path="tracker" element={<ApplicationTracker />} />
            <Route path="interview" element={<InterviewCopilot />} />
            <Route path="practice" element={<FaceToFaceInterview />} />
            {/* <Route path="analytics" element={<CareerAnalytics />} /> */}
          </Route>

          <Route path="/recruiter" element={<ProtectedRoute role="recruiter"><AppShell /></ProtectedRoute>}>
            <Route index element={<RecruiterDashboard />} />
            <Route path="candidates" element={<CandidateSearch />} />
            <Route path="candidates/:id" element={<CandidateDetail />} />
            <Route path="post" element={<PostJob />} />
            <Route path="pipeline" element={<RecruiterPipeline />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
